import axios from "axios"

import client from "~/v2/api/client"
import { mapArrayField, normalizeApiPayload } from "~/v2/mappers/vaas-helpers"
import type { VaasCaption, VaasId } from "~/v2/types/vaas"

type CloudflareCredentialsParams = {
  metadata: Record<string, string>
  name: string
  uploadLength: number
}

type SrtUploadParams = {
  fields: Record<string, string | Blob>
  file: File
  url: string
}

const uploadThumbnail = (file: File, cloudinaryUploadPreset: string) => {
  const form = new FormData()
  form.append("upload_preset", cloudinaryUploadPreset)
  form.append("file", file)

  return axios.post(
    `https://api.cloudinary.com/v1_1/${import.meta.env.VITE_CLOUDINARY_CLOUD_NAME}/upload`,
    form,
    { headers: { "Content-Type": "multipart/form-data" } },
  )
}

const requestSignedUrl = () =>
  client
    .get("/videos/request")
    .then((response: any) => normalizeApiPayload(response.data))

const createCloudflareVideo = (data: Record<string, unknown>): Promise<any> =>
  client.post("/cloudflare/videos", data).then((response: any) => response.data)

const requestCloudflareCredentials = ({
  uploadLength,
  metadata,
  name,
}: CloudflareCredentialsParams): Promise<any> =>
  client
    .post("/cloudflare/upload-url", { metadata, name, uploadLength })
    .then((response: any) => normalizeApiPayload(response.data))

const requestSrtUpload = (data: Record<string, unknown>): Promise<any> =>
  client
    .post("/videos/request/srt", data)
    .then((response: any) => response.data)

const uploadSrt = ({ fields, file, url }: SrtUploadParams, opts?: any) => {
  const form = new FormData()
  for (const [key, value] of Object.entries(fields)) {
    form.append(key, value)
  }
  form.append("file", file)
  return axios.post(url, form, opts)
}

const addSrt = (
  data: Record<string, unknown>,
  id: VaasId,
): Promise<{ data: VaasCaption[] } & Record<string, unknown>> =>
  client.post(`/videos/${id}/srt`, data).then((response: any) => ({
    ...response.data,
    data: mapArrayField(response.data?.data),
  }))

export {
  addSrt,
  createCloudflareVideo,
  requestCloudflareCredentials,
  requestSignedUrl,
  requestSrtUpload,
  uploadSrt,
  uploadThumbnail,
}
